module.exports = __webpack_public_path__ + "img/interview.d197ab47.png";